import axios from "axios";
import { IAPIResponse } from "../../types/IAPIResponse";
import {
  AdminAssignPlacementListDTO,
  AdminPlacementListDTO,
} from "../types/NotificationTypes";
import { IOption } from "../../types/Codes/IOptions";
import { ImportPlacementExamRequestDocumentDto } from "../../types/Applicant/UploadedDocumentDTO";

export class PlacementExamAPI {
  async AssignPlacementExam(
    data: AdminAssignPlacementListDTO
  ): Promise<IAPIResponse<string[]>> {
    const response = await axios.post<IAPIResponse>(
      "/admin/placementexam/assignlist",
      data
    );
    let res: IAPIResponse<string[]> = response.data;
    return Promise.resolve(res);
  }

  async PlacementExamList(
    id: number
  ): Promise<IAPIResponse<AdminPlacementListDTO[]>> {
    const response = await axios.get<IAPIResponse>(
      "/admin/placementexam/placementexamlist/" + id
    );
    let res: IAPIResponse<AdminPlacementListDTO[]> = response.data;
    return Promise.resolve(res);
  }

  async PlacementExams(): Promise<IAPIResponse<IOption[]>> {
    const response = await axios.get<IAPIResponse>(
      "/admin/placementexam/listofexams/"
    );
    let res: IAPIResponse<IOption[]> = response.data;
    return Promise.resolve(res);
  }

  async ImportResults(
    data: ImportPlacementExamRequestDocumentDto
  ): Promise<IAPIResponse<Boolean>> {
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };

    const payload = {
      term: data.term,
      results: data.results,
    };

    const response = await axios.post<IAPIResponse<Boolean>>(
      "/admin/placementexam/importresults",
      payload,
      config
    );
    let newdocument: IAPIResponse<Boolean> = response.data;
    return new Promise<IAPIResponse<Boolean>>((resolve, reject) => {
      resolve(newdocument);
    });
  }
}
